const { getOffsetTop } = window.BAO.Utils

class FeatureHighlights extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.activeCardIndex = -1

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.checkProgress()
    this.setCardsBlur()
  }

  checkProgress () {
    if (!this.offsetHeight) return

    const maxItems = this.els.card.elements.length - 1

    const elementHeight = this.els.cards.element.offsetHeight

    const windowTriggerPoint = window.innerHeight / 2.5

    const elementStartPoint =
      getOffsetTop(this.els.cards.element) - windowTriggerPoint
    const elementEndPoint = elementStartPoint + elementHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.setActiveCard(0)

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.setActiveCard(maxItems)
    }

    this.els.card.elements.forEach((cardEl, index) => {
      const cardStartPoint = getOffsetTop(cardEl) - windowTriggerPoint
      const cardEndPoint = cardStartPoint + cardEl.offsetHeight

      const isWithinRange =
        this.lastKnownY >= cardStartPoint && this.lastKnownY < cardEndPoint

      if (isWithinRange) {
        this.setActiveCard(index)
      }
    })
  }

  setActiveCard (activeCardIndex) {
    if (activeCardIndex === this.activeCardIndex) return

    this.activeCardIndex = activeCardIndex

    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.index === this.activeCardIndex.toString(),
      )
    })

    this.els.number.elements.forEach((numberEl) => {
      numberEl.style.setProperty(
        '--Number_Offset',
        `${this.activeCardIndex * -100}%`,
      )
    })
  }

  setCardsBlur () {
    if (!this.offsetHeight) return

    this.els.card.elements.forEach((cardEl) => {
      const maxBlur = 10

      const elementStartPoint = getOffsetTop(cardEl) - window.innerHeight
      const elementEndPoint = elementStartPoint + window.innerHeight / 2

      if (this.lastKnownY <= elementStartPoint) {
        cardEl.style.setProperty('--Blur_Amount', `${maxBlur}px`)
        cardEl.style.setProperty('--Card_Opacity', 0)

        return
      }

      if (this.lastKnownY > elementEndPoint) {
        cardEl.style.setProperty('--Blur_Amount', '0px')
        cardEl.style.setProperty('--Card_Opacity', 1)

        return
      }

      const totalScrollAmount = elementEndPoint - elementStartPoint

      const scrollYAsAPercentageOfJourney =
        1 - (this.lastKnownY - elementStartPoint) / totalScrollAmount

      const blurAmount = maxBlur * scrollYAsAPercentageOfJourney

      cardEl.style.setProperty('--Blur_Amount', `${blurAmount}px`)
      cardEl.style.setProperty(
        '--Card_Opacity',
        1 - scrollYAsAPercentageOfJourney,
      )
    })
  }

  handleTrigger (event) {
    const triggerIndex = event.target.dataset.index

    const matchedCard = this.els.card.elements.find(
      (cardEl) => cardEl.dataset.index === triggerIndex,
    )

    if (!matchedCard) return
    matchedCard.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

if (!customElements.get('feature-highlights')) {
  customElements.define('feature-highlights', FeatureHighlights)
}
